module.exports = __webpack_public_path__ + "static/img/y44.4330118.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y44.jpg
// module id = PuyO
// module chunks = 1